var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpiIconMobileMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0.5H2.5C1.67157 0.5 1 1.17157 1 2C1 2.82843 1.67157 3.5 2.5 3.5H24.5C25.3284 3.5 26 2.82843 26 2C26 1.17157 25.3284 0.5 24.5 0.5Z",
    fill: "#FC0444",
    stroke: "#FC0444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.62 8.5H4.38C3.61785 8.5 3 9.17157 3 10C3 10.8284 3.61785 11.5 4.38 11.5H24.62C25.3822 11.5 26 10.8284 26 10C26 9.17157 25.3822 8.5 24.62 8.5Z",
    fill: "#FC0444",
    stroke: "#FC0444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8 16.5H7.2C6.53726 16.5 6 17.1716 6 18C6 18.8284 6.53726 19.5 7.2 19.5H24.8C25.4627 19.5 26 18.8284 26 18C26 17.1716 25.4627 16.5 24.8 16.5Z",
    fill: "#FC0444",
    stroke: "#FC0444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpiIconMobileMenu);
export default __webpack_public_path__ + "static/media/gpi-icon-mobile-menu.3d0c26cc.svg";
export { ForwardRef as ReactComponent };